import {LoginRedirectFetch} from "../environment/LoginRedirectFetch";

export class CourseService {
    private loginRedirectFetch: LoginRedirectFetch

    constructor() {
        this.loginRedirectFetch = new LoginRedirectFetch(window.location);
    }

    async getCoursesByYear(year: Number): Promise<string> {
         const response = await this.loginRedirectFetch.fetch(`/api/courses/list/${year}`, {
            method: "GET",
            credentials: "include"
        })
        return response.json();
    }

    async adminGetCoursesWithBookings(): Promise<any> {
        const response = await this.loginRedirectFetch.fetch("/api/courses/bookings", {
            method: "GET",
            credentials: "include"
        })
        return response.json();
    }

    async getCourse(alias: string | undefined): Promise<string | any> {
        const response = await this.loginRedirectFetch.fetch(`/api/course-templates/view/${alias}`, {
            method: "GET",
            credentials: "include"
        })
        return response.json();
    }
}
